import * as React from 'react'

const FormSubmittedAnim = () => {
  return (
    <section className="inset-0 absolute z-10 flex justify-center items-center">
      <div className="inset-0 absolute bg-[rgba(255,255,255,.8)] backdrop-blur-[2px] fade-in-now" />
      <div className={'z-10 h-48 max-h-48 max-w-48 aspect-square'}>
        <svg viewBox="0 0 16 16">
          <style>{`
.circle-submit {
  stroke-width: .09rem;
  stroke: #bb0606;
  fill: none;
  stroke-linecap: round;
  stroke-dasharray: 2.65rem;
  stroke-dashoffset: 1.07rem;
  animation: dash 1s ease-in-out forwards;
}
.checkmark-submit {
  fill: #bb0606;
  opacity: 0;
  scale: 1;
  transform-origin: center center;
  animation: checkmark .4s cubic-bezier(.59,-0.24,.43,1.37) forwards 1s;
}
@keyframes dash {
  0% {
    stroke-dasharray: 2.65rem;
    stroke-dashoffset: 3.3rem;
  }
  100% {
    stroke-dasharray: 2.65rem;
    stroke-dashoffset: 1.07rem;
  }
}
@keyframes checkmark {
  0% {
    opacity: 0;
    scale: .6;
  }
  90% {
    opacity: 1;
    scale: 1.2;
  }
  100% {
    opacity: 1;
    scale: 1;
  }
}
`}</style>
          <circle className="circle-submit" cx="7.2" cy="9" r="5" />
          <path
            className="checkmark-submit"
            d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"
          />
        </svg>
      </div>
    </section>
  )
}

export default FormSubmittedAnim
